/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { CSVLink } from 'react-csv';
// import makeAnimated from 'react-select/lib/animated';
import Axios from "axios";
// Styles
import './Reconciliation.scss';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
//import { history } from '../../../../store';
//import { Link } from 'react-router';

// Utils
import {
  stableSort,
  getSorting, roundingMoney,
} from '../../../../utils/functions';
import {inAdminPermissions, inFinance} from "../../../../utils/authChecker";

import Icon from '../../../../global/images/icons/Icon';

import {
  Button, Dialog,
  DialogActions,
  DialogContent, DialogTitle, styled,
  Typography
} from '@material-ui/core';
import PromptDialog from "../../../dialog/PromptDialog";
import {getCurCurrencyOfUnit, getLocalDay} from "../../../../utils/util";
import suspiciousIcon from "../../../../images/quest-state/suspicious.png";
import {simpleNotification} from "../../../../utils/notifications";
//import ReactTooltip from "react-tooltip";
//import {getReconciliationRollCsv} from "../../../../epics/adminEpic";
//import {simpleNotification} from "../../../../utils/notifications";

/*const paypalStatusKey = [
  { label: 'approve', value: 0 ,color:'white'},
  { label: 'accept', value: 1 ,color:'green'},
  { label: 'reject', value: 2 ,color:'red'},
];*/

const TableHeaderCell = withStyles(theme => ({
  head: {
    color: '#9b9b9b',
    fontWeight: '400',
    letterSpacing: '1.2px',
    fontSize: '14px',
  },
}))(TableCell);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialog-paperWidthSm': {
    backgroundColor: '#322d38',
    borderRadius:'8px',
    display:'flex',
    alignItems:'center',
    width:'500px',
    padding:'10px'
  },
  '& .MuiDialogContent-dividers': {
    borderTop:'0px',
    borderBottom:'0px'
  },
  '& .MuiTypography-h6': {
    textTransform:'none'
  },
  '& .pay-note': {
    width:'100%',
    padding:'8px',
    background:'#2d2d2d',
    border:'1px solid #3d3d3d',
    borderRadius: '4pxv',
    color:'#ffffff',
  },
}));

class Reconciliation extends React.Component {
  constructor(props) {
    super(props);
    const endDate = new Date();
    const startDate = props.admin.rollOutsAll.startDate?new Date(props.admin.rollOutsAll.startDate):new Date();
    if(!props.admin.rollOutsAll.startDate) {
      startDate.setDate(endDate.getDate() - 7)
    }

    this.props = props;
    this.state = {
      orderBy: false,
      order: 'desc',
      numPage: 1,
      questTab: 2,
      filtersModal: false,
      daysFilter: 1,
      questsOptions: [],
      paypalLoaded: false,
      filters: {
        searchAll: true,
        searchSubject: false,
        searchNoizEmail: false,
        searchNoiz: false,
        paypalStatusAll: true,
        paypalStatusSuccess: false,
        paypalStatusDenied: false,
        paypalStatusPending: false,
        paypalStatusRefunded: false,
        paypalStatusPartiallyRefunded: false,
        searchValue: '',
        startDate:startDate,
        endDate:endDate,
        approveStatus:"0,",
        irs:1,
        region:props?.auth?.user?.permission?.regions[0]?.id||'',
        getAbnormal:0,
      },

      filtersClear: {
        searchAll: true,
        searchSubject: false,
        searchNoizEmail: false,
        searchNoiz: false,
        paypalStatusAll: true,
        paypalStatusSuccess: false,
        paypalStatusDenied: false,
        paypalStatusPending: false,
        paypalStatusRefunded: false,
        paypalStatusPartiallyRefunded: false,
        searchValue: '',
        startDate:startDate,
        endDate:endDate,
        approveStatus:"0,",
      },
      search:"",
      dateStart:startDate,
      dateEnd:endDate,
      filtersBackup: {},
      sorting: false,
      approveOrderId:"",
      approveType:0,
      deductOrder:{userId:'',userName:'',balance:0,currency:'',deductNote:'',walletBalance:'',email:'',accountBalance:0,orderId:''},
      dialogConfirmOpen:false,
      dialogRefuseOpen:false,
      dialogResultOpen:false,
      dialogRefuseResultOpen:false,
      payResult:false,
      payResultOpen:false,
      payRemind:false,
      payBatch:false,
      paymentsSel:[],
      dialogConfirmBatchOpen:false,
      dialogBatchSuccessOpen:false,
      payBatchSuccess:null,
      dialogBatchFailureOpen:false,
      dialogBatchFailure:[],
      payNote:"",
      balanceTip:"",
      deductNoteTip:"",
      questTableUserId:"",
      selectIndex:0,
    };
  }

  handleStartDateChange = (date) =>{
    //const newDateStart = event.target.value
    //console.log(newDateStart,typeof newDateStart);
    if(date){
     // const date = new Date(newDateStart);
     // date.setHours(0,0,0,0);
      //console.log(date,typeof date);
      this.setState(prevState =>({
        filters:{
          ...prevState.filters,
          startDate:date
        },
        numPage:1,
        selectIndex:0,
      }),()=>{this.doSearch()});
    }

  }

  handleEndDateChange = (date) =>{
   // const newDateEnd = event.target.value
    if(date){
     // let date = new Date(newDateEnd);
      //date.setHours(23,59,59,999);
      //console.log(date,typeof date);
      this.setState(prevState =>({
        filters:{
          ...prevState.filters,
          endDate:date
        },
        numPage:1,
        selectIndex:0,
      }),()=>{this.doSearch()});
    }
  }

  handleSelectIndexDateChange = (dateStart,dateEnd,getAbnormal=0) =>{
    // const newDateEnd = event.target.value
    if(dateStart&&dateEnd){
      // let date = new Date(newDateEnd);
      //date.setHours(23,59,59,999);
      //console.log(date,typeof date);
      this.setState(prevState =>({
        filters:{
          ...prevState.filters,
          startDate:dateStart,
          endDate:dateEnd,
          getAbnormal
        },
        numPage:1,
      }),()=>{this.doSearch()});
    }
  }

  UNSAFE_componentWillMount() {
    if (!this.props.admin.rollOuts.isLoading) {
      this.doSearch();
     // this.props.getRollOutRecord(this.state.numPage,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
      this.setState(prevState =>({
        filters:{
          ...prevState.filters,
          irs:0
        }
      }));
    }
    if (!this.props.admin.rollOutsAll.isLoading) {
      //this.props.getRollOutAll(0,',', '{"tip":true,"approveStatus":0}', false, token,0);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { deductOrderId:approveOrderId } = this.props.admin.deduct.data;
    //const { data:approve,isLoading} = this.props.admin.orderLink;
    //const {Pagination:tipPagination } = this.props.admin.rollOutsAll;
    //console.log(approveOrderId,'---',this.state.approveOrderId);
    if (this.state.filters !== prevState.filters||this.state.search!==prevState.search||this.state.sorting!==prevState.sorting) {
      this.setState({
        numPage: 1,
      });
     // this.props.getRollOutRecord(1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
     // this.props.getRollOutAll(0,',', '{"tip":true,"approveStatus":0}', false, token,0);
    }else if(approveOrderId&&approveOrderId!==this.state.approveOrderId){
      this.doSearch();
      //this.props.getRollOutRecord(this.state.numPage,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
        //this.props.getRollOutAll(0,',', '{"tip":true,"approveStatus":0}', false, token,0);
      this.setState({
        approveOrderId: approveOrderId,
      });
    }
    //this.props.tip(tipPagination?tipPagination.totalUsers:0);
    if ((prevProps.admin.revokeDeduct.isLoading === true && this.props.admin.revokeDeduct.isLoading === false)) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (this.props.admin.revokeDeduct.errors.hasError) {
      }else{
        this.doSearch();
      }
      this.handleRefuseResultOpen();
    }
    if ((prevProps.admin.deduct.isLoading === true && this.props.admin.deduct.isLoading === false)) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (this.props.admin.deduct.errors.hasError) {
      }else{
      }
      this.handleResultOpen();
    }
    if ((prevProps.admin.rollOuts.isLoading === true && this.props.admin.rollOuts.isLoading === false)) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (this.props.admin.rollOuts.errors.hasError) {
      }else{
        if(this.props.admin.rollOuts.startDate){
          this.setState(prevState =>({
            filters:{
              ...prevState.filters,
              startDate:new Date(this.props.admin.rollOuts.startDate),
              //endDate:new Date(this.props.admin.rollOuts.endDate),
            }
          }));
        }
      }
    }
    if ((prevProps.admin.approve.isLoading === true && this.props.admin.approve.isLoading === false)) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (this.props.admin.approve.errors.hasError) {
        simpleNotification({
          level: 'error',
          title: 'Error deal failure.',
          message: this.props.admin.approve.errors.message,
        });
      }else{
        this.doSearch();
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //const { token } = this.props.auth;

    if (this.props.admin.quests.isLoading === true && nextProps.admin.quests.isLoading === false) {
      const { data: quests } = nextProps.admin.quests;

      if (quests) {
        const questsOptions = [];
        for (let i = 0; i < quests.length; i++) {
          questsOptions.push({ value: quests[i].id, label: quests[i].title });
        }

        this.setState({
          //questsOptions,
        });
      }
    }

    // If paypal just refreshed, get payments again
    if (this.props.admin.rollOuts.isLoading === true && nextProps.admin.rollOuts.isLoading === false) {
      this.setState({
        //paypalLoaded: true,
      });
      //this.props.getAPaymentList(this.state.numPage, JSON.stringify(this.state.filters), this.state.sorting, token);
    }
  }

  doSearch=()=>{
    const { token } = this.props.auth;
    this.props.getReconciliationRollRecord(this.state.numPage,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    this.setState({
      searchType: 0,
    });
  }

  paginationRight = () => {
    const { pagination } = this.props.admin.reconciliationRolls;
    if (pagination.totalPages < this.state.numPage + 1) {
      return;
    }
    if (!this.props.admin.rollOuts.isLoading) {
      //this.props.getRollOutRecord(this.state.numPage + 1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    this.setState({
      numPage: this.state.numPage + 1,
    },()=>{this.doSearch()});
  }

  paginationLeft = () => {
    if (this.state.numPage === 1) {
      return;
    }
    if (!this.props.admin.rollOuts.isLoading) {
      //this.props.getRollOutRecord(this.state.numPage - 1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    this.setState({
      numPage: this.state.numPage - 1,
    },()=>{this.doSearch()});
  }

  handleSearchValueChange(event) {

    this.setState({
      //filters: {
        //...this.state.filters,
       // searchValue: event.target.value,
      //},
      search:event.target.value,
    });
  }

  openFiltersModal = () => {
    this.setState({
      filtersModal: true,
      filtersBackup: { ...this.state.filters },
    });
  }

  closeFiltersModal = () => {
    this.setState({
      filtersModal: false,
      filters: { ...this.state.filtersBackup },
    });
  }

  clearFiltersModal = () => {
    this.setState({
      filters: { ...this.state.filtersClear },
    });
  }

  applyFilters = () => {
    //const { token } = this.props.auth;

    this.setState({
      filtersModal: false,
    });

   // this.props.getAPaymentList(1, JSON.stringify(this.state.filters), this.state.sorting, token);
  }

  changeFilterSearch(name) {
    switch (name) {
      case 'searchAll':
        this.setState({
          filters: {
            ...this.state.filters,
            searchAll: true,
            searchSubject: false,
            searchNoiz: false,
            searchNoizEmail: false,
          },
        });
        break;
      case 'searchSubject':
        this.setState({
          filters: {
            ...this.state.filters,
            searchSubject: !this.state.filters.searchSubject,
            searchAll: false,
          },
        });
        break;
      case 'searchNoizEmail':
        this.setState({
          filters: {
            ...this.state.filters,
            searchNoizEmail: !this.state.filters.searchNoizEmail,
            searchAll: false,
          },
        });
        break;
      case 'searchNoiz':
        this.setState({
          filters: {
            ...this.state.filters,
            searchNoiz: !this.state.filters.searchNoiz,
            searchAll: false,
          },
        });
        break;
      default:
        this.setState({});
    }
  }

  // changePayoutFilter(name) {
  //   switch (name) {
  //     case 'paymentStatusAll':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusAll: !this.state.filters.paymentStatusAll,
  //           paymentStatusSent: false,
  //           paymentStatusFailed: false,
  //           paymentStatusNotSent: false,
  //         },
  //       });
  //       break;
  //     case 'paymentStatusSent':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusSent: !this.state.filters.paymentStatusSent,
  //           paymentStatusAll: false,
  //         },
  //       });
  //       break;
  //     case 'paymentStatusFailed':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusFailed: !this.state.filters.paymentStatusFailed,
  //           paymentStatusAll: false,
  //         },
  //       });
  //       break;
  //     case 'paymentStatusNotSent':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusNotSent: !this.state.filters.paymentStatusNotSent,
  //           paymentStatusAll: false,
  //         },
  //       });
  //       break;
  //     default:
  //       this.setState({});
  //   }
  // }

  changePayPalFilter(name) {
    switch (name) {
      case 'paypalStatusAll':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusAll: !this.state.filters.paypalStatusAll,
            paypalStatusSuccess: false,
            paypalStatusDenied: false,
            paypalStatusPending: false,
            paypalStatusRefunded: false,
            paypalStatusPartiallyRefunded: false,
          },
        });
        break;
      case 'paypalStatusSuccess':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusSuccess: !this.state.filters.paypalStatusSuccess,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusDenied':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusDenied: !this.state.filters.paypalStatusDenied,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusPending':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusPending: !this.state.filters.paypalStatusPending,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusRefunded':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusRefunded: !this.state.filters.paypalStatusRefunded,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusPartiallyRefunded':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusPartiallyRefunded: !this.state.filters.paypalStatusPartiallyRefunded,
            paypalStatusAll: false,
          },
        });
        break;
      default:
        this.setState({});
    }
  }

  setPaymentFromDate = (event) => {
    const { target: { value } } = event;
    if (value) {
      const paymentFromDate = new Date(value).toISOString().slice(0, 10);
      this.setState({
        filters: {
          ...this.state.filters,
          paymentFromDate,
        },
      });
    } else if (value === '') {
      this.setState({
        filters: {
          ...this.state.filters,
          paymentFromDate: null,
        },
      });
    }
  }

  setPaymentToDate = (event) => {
    const { target: { value } } = event;
    if (value) {
      const paymentToDate = new Date(value).toISOString().slice(0, 10);
      this.setState({
        filters: {
          ...this.state.filters,
          paymentToDate,
        },
      });
    } else if (value === '') {
      this.setState({
        filters: {
          ...this.state.filters,
          paymentToDate: null,
        },
      });
    }
  }

  // Determine sort direction for property; set state.order and state.orderBy
  handleRequestSort = (event, property) => {
    if(property) {
      const desc = this.state.order === 'desc' && this.state.orderBy === property;
      this.setState({
        order: desc ? 'asc' : 'desc',
        orderBy: property,
        sorting: {
          order: desc ? 'asc' : 'desc',
          orderBy: property ? property : false,
        },
        numPage: 1,
      }, () => {
        this.doSearch()
      });
    }
  }

  handleQuestFilterChange(selectedOptions) {
    this.setState({
      filters: {
        ...this.state.filters,
        quests: selectedOptions,
      },
    });
  }

  renderFiltersModal() {
    return (
      <section className="ModalMaster active">
        <section className="Modal active">
          <button onClick={this.closeFiltersModal.bind(this)} className="Modal__layer" aria-hidden />
          <section className="Modal__wrapper Filters">
            <div className="Filters__title">
              Select the filters you want to apply
            </div>

            <div className="Filters__title left">
              Report for a specific user:
            </div>

            <div className="Filters__section">
              <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div className="Filters__field__label" style={{ marginRight: '10px' }}>
                  Search by:
                </div>
                <div className="Filters__fieldGroup" style={{ marginTop: '0px', marginBottom: '0px' }}>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchAll', false)}
                    className={classNames('', { active: this.state.filters.searchAll })}
                  >
                    All
                  </button>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchSubject', false)}
                    className={classNames('', { active: this.state.filters.searchSubject })}
                  >
                    Subject
                  </button>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchNoizEmail')}
                    className={classNames('', { active: this.state.filters.searchNoizEmail })}
                  >
                    Noiz Email
                  </button>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchNoiz')}
                    className={classNames('', { active: this.state.filters.searchNoiz })}
                  >
                    Noiz Username
                  </button>
                </div>
              </div>
              <div className="Filters__fieldGroup" style={{ marginTop: '0px' }}>
                <input
                  type="text"
                  value={this.state.filters.searchValue}
                  onChange={this.handleSearchValueChange.bind(this)}
                  style={{ display: 'flex' }}
                />
              </div>
            </div>

            <div className="Filters__title left">
              Filter options:
            </div>


            <div className="Filters__section">
              {/* <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div className="Filters__field__label" style={{ marginRight: '10px' }}>
                  Payout Status:
                </div>
                <div className="Filters__fieldGroup" style={{ marginTop: '0px', marginBottom: '0px' }}>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusAll')}
                    className={classNames('', { active: this.state.filters.paymentStatusAll })}
                  >
                    All
                  </button>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusSent')}
                    className={classNames('', { active: this.state.filters.paymentStatusSent })}
                  >
                    Sent
                  </button>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusFailed')}
                    className={classNames('', { active: this.state.filters.paymentStatusFailed })}
                  >
                    Failed
                  </button>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusNotSent')}
                    className={classNames('', { active: this.state.filters.paymentStatusNotSent })}
                  >
                    Not Sent
                  </button>
                </div>
              </div> */}
              <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div className="Filters__field__label" style={{ marginRight: '10px', marginTop: '20px' }}>
                  PayPal Status:
                </div>
                <div className="Filters__fieldGroup" style={{ marginTop: '0px', marginBottom: '0px' }}>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusAll')}
                    className={classNames('', { active: this.state.filters.paypalStatusAll })}
                  >
                    All
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusSuccess')}
                    className={classNames('', { active: this.state.filters.paypalStatusSuccess })}
                  >
                    Success
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusDenied')}
                    className={classNames('', { active: this.state.filters.paypalStatusDenied })}
                  >
                    Denied
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusPending')}
                    className={classNames('', { active: this.state.filters.paypalStatusPending })}
                  >
                    Pending
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusRefunded')}
                    className={classNames('', { active: this.state.filters.paypalStatusRefunded })}
                  >
                    Refunded
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusPartiallyRefunded')}
                    className={classNames('', { active: this.state.filters.paypalStatusPartiallyRefunded })}
                  >
                    Partially Refunded
                  </button>
                </div>
              </div>
            </div>

            <div className="Filters__section" style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
              <div className="Filters__field__label" style={{ marginRight: '10px', marginTop: '20px', float: 'left' }}>
                Transaction Date:
              </div>
              <div className="date__section">
                From Date
                <input
                  type="date"
                  value={this.state.filters.paymentFromDate}
                  onChange={this.setPaymentFromDate.bind(this)}
                  className="date__picker"
                />
              </div>
              <span style={{ margin: '0px 10px' }}> - </span>
              <div className="date__section">
                To Date
                <input
                  type="date"
                  value={this.state.filters.paymentToDate}
                  onChange={this.setPaymentToDate.bind(this)}
                  className="date__picker"
                />
              </div>
            </div>
            <div className="Filters__section" style={{ marginTop: '20px' }}>
              {/* }  <div className="Filters__fieldGroup">
                <div className="Filters__field__label">
                  Quests:
                </div>
                <Select
                  value={this.state.filters.quests}
                  closeMenuOnSelect={false}
                  components={makeAnimated()}
                  isMulti
                  onChange={(...args) => this.handleQuestFilterChange(...args)}
                  options={this.state.questsOptions}
                  styles={colourStyles}
                />
              </div> */}
            </div>

            <div className="Filters__close" style={{ paddingTop: '20px' }}>
              <button
                onClick={this.closeFiltersModal.bind(this)}
              >
                <i className="fa fa-times" /> Cancel
              </button>
              <button
                onClick={this.clearFiltersModal.bind(this)}
              >
                <i className="fa fa-eraser" /> Clear
              </button>
              <button
                onClick={this.applyFilters.bind(this)}
              >
                <i className="fa fa-check" /> Apply
              </button>
            </div>
          </section>
        </section>
      </section>
    );
  }

  renderFiltersString = (forFileName) => {
    const { filters } = this.state;
    const filterArray = [];

    if (filters.searchAll && filters.searchValue) {
      filterArray.push(`Subject: ${filters.searchValue}`);
      filterArray.push(`Noiz Email: ${filters.searchValue}`);
      filterArray.push(`Noiz Username: ${filters.searchValue}`);
    } else if (filters.searchsearchSubject) {
      filterArray.push(`Subject: ${filters.searchValue}`);
    } else if (filters.searchNoizEmail) {
      filterArray.push(`Noiz Email: ${filters.searchValue}`);
    } else if (filters.searchNoiz) {
      filterArray.push(`Noiz Username: ${filters.searchValue}`);
    }

    // if (filters.paymentStatusAll) {
    //   filterArray.push('Payout Status: All');
    // } else {
    //   let paymentFilters = [];
    //   if (filters.paymentStatusSent) {
    //     paymentFilters.push('Sent');
    //   }
    //   if (filters.paymentStatusFailed) {
    //     paymentFilters.push('Failed');
    //   }
    //   if (filters.paymentStatusNotSent) {
    //     paymentFilters.push('Not Sent');
    //   }
    //   if (paymentFilters.length) {
    //     filterArray.push('Payment Status: ' + paymentFilters.join(", "));
    //   }
    // }

    if (filters.paypalStatusAll) {
      //filterArray.push('Paypal Status: All');
    } else {
      const paypalFilters = [];
      if (filters.paypalStatusPending) {
        paypalFilters.push('Pending');
      }
      if (filters.paypalStatusSuccess) {
        paypalFilters.push('Success');
      }
      if (filters.paypalStatusDenied) {
        paypalFilters.push('Denied');
      }
      if (filters.paypalStatusRefunded) {
        paypalFilters.push('Refunded');
      }
      if (filters.paypalStatusPartiallyRefunded) {
        paypalFilters.push('Partially Refunded');
      }

      if (paypalFilters.length) {
        filterArray.push(`Paypal Status: ${paypalFilters.join(', ')}`);
      }
    }

    // if (filters.quests) {
    //   filterArray.push('Quests: ' + filters.quests.map((quest) => quest.label).join(", "));
    // }

    if (filters.startDate && filters.endDate) {
      filterArray.push(`Transaction Date: ${moment(filters.startDate).format('MMMM DD, YYYY')} - ${moment(filters.endDate).format('MMMM DD, YYYY')}`);
    } else if (filters.startDate) {
      filterArray.push(`Transaction Date: After ${moment(filters.startDate).format('MMMM DD, YYYY')}`);
    } else if (filters.endDate) {
      filterArray.push(`Transaction Date: Before ${moment(filters.endDate).format('MMMM DD, YYYY')}`);
    }

    if (filterArray.length === 0) {
      return 'None';
    }

    // Determine delimiter
    if (forFileName) {
      const filterStrings = filterArray.map(filter => filter.replace(/[^a-z0-9+]+/gi, '-'));
      return filterStrings.join('_');
    }
    return filterArray.join(', ');
  }


  // Sort & define payment rows; return elements to display
  getRollOutsRows = (payments) => {
    if (payments.length) {
      const{ questTableUserId } = this.state;
      const sortedPayments = stableSort(payments, getSorting(this.state.order, this.state.orderBy));
      return sortedPayments.map(payment => (
          <>
        <TableRow hover tabIndex={-1} key={payment.id}>
          <TableCell align="center">{(!payment.normal)&&<img
              src={suspiciousIcon}
              alt="Suspicious"
              style={{ width: '16px', height: '16px',marginRight:'10px'}}
          />}{payment.userName ? payment.userName : '-'}</TableCell>
          <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,payment.rollInSum)}{payment.rollInSum>0&&(<i className="fa fa-search" style={{marginLeft:'5px',cursor:'pointer'}} onClick={this.handleRollIns.bind(this,payment.userName)}></i>)}</TableCell>
          <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,payment.balance)}</TableCell>
          <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,payment.withdrawSum)}{(payment.withdrawSum>0)&&(<i className="fa fa-search" style={{marginLeft:'5px',cursor:'pointer'}} onClick={this.handleRollOuts.bind(this,payment.userName)}></i>)}</TableCell>
          <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,payment.cdkOrderSum)}{(payment.cdkOrderSum>0)&&(<i className="fa fa-search" style={{marginLeft:'5px',cursor:'pointer'}} onClick={this.handleCDKOrders.bind(this,payment.userName)}></i>)}</TableCell>
          <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,payment.deduceSum)}{(payment.deduces&&payment.deduces.length>0)&&(<i className={this.state.questTableUserId===payment.userId?"fa fa-minus-square-o":"fa fa-plus-square-o"} style={{marginLeft:'5px',cursor:'pointer'}} onClick={this.handleDeduceItem.bind(this,payment.userId)}></i>)}</TableCell>
          <TableCell align="center">
            {payment.wallet&&<button style={{'backgroundColor':'green','width':'60px'}} onClick={this.handleConfirmOpen.bind(this,payment.userId,payment.userName,payment.balance,payment.accountBalance,payment.currency,payment.userEmail)}>deduct</button>}
            {!payment.wallet&&<button style={{'backgroundColor':'red','width':'100px',marginLeft:'10px'}} onClick={this.handleWalletError.bind(this,payment.userId)}>wallet error</button>}
          </TableCell>
        </TableRow>

            {questTableUserId===payment.userId&&<TableRow>
        <TableCell colspan="7">
        <section className="ToggleTable__table-wrapper__item">
          <section className="ToggleTable__table flex-table">
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeaderCell align="center">Date</TableHeaderCell>
                  <TableHeaderCell align="center">Amount</TableHeaderCell>
                  <TableHeaderCell align="center">Reason for deduction</TableHeaderCell>
                  <TableHeaderCell align="center">Operator</TableHeaderCell>
                  <TableHeaderCell align="center"></TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {payment.deduces&&payment.deduces.length>0&&payment.deduces?.map(d=>(
                <TableRow hover tabIndex={-1} key={d.id}>
                  <TableCell align="center">{d.createdAt ? moment(d.createdAt).format('YYYY-MM-DD h:mm a') : '-'}</TableCell>
                  <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,d.balance)}</TableCell>
                  <TableCell align="center">{d.note ? d.note : '-'}</TableCell>
                  <TableCell align="center">{d.dealUserName ? d.dealUserName : '-'}{d.quitDeductUserName ? '/'+d.quitDeductUserName : ''}</TableCell>
                  <TableCell align="center">
                    {d.status==='d'&&<button style={{'backgroundColor':'#ff0000','width':'60px'}} onClick={this.handleRefuseOpen.bind(this,d.id,d.balance,payment.userName,payment.currency)}>revoke</button>}
                    {d.status==='q'&&<p style={{color:"green",fontSize:"14px"}}>It was revoked on {moment(d.updatedAt).format('YYYY-MM-DD h:mm a')}</p>}
                  </TableCell>
                </TableRow>
                ))}
                {(!payment.deduces||payment.deduces.length<=0)&&(<TableRow> <TableCell align="center" colspan="5">No Records</TableCell></TableRow>)}
              </TableBody>
            </Table>
          </section>
        </section>
        </TableCell>
      </TableRow>}
          </>
      ));
    }
  }

  handleSearchChange(event) {
    //const { target: { value } } = event;
    this.setState({
      search: event.target.value,
    });
  }

  handleSearch = (event) =>{
    const { search } = this.state
    console.log("method search called!,search string is:",search)
    this.setState({
      numPage: 1,
    },()=>{this.doSearch()});
  }

  // Define table headers; return array of headers
  getTableHeaders = () => {
    const tableHeaders = [
      /*{
        id: 'Date', numeric: false, disablePadding: true, label: 'Date',
      },*/
      {
        id: 'userName', numeric: false, disablePadding: true, label: 'UserName',
      },
      {
        id: 'totalPayment', numeric: false, disablePadding: true, label: 'Total payment',
      },
      {
        id: 'walletBalance', numeric: false, disablePadding: true, label: 'Wallet Balance',
      },
      {
        id: 'withdrawnAmount', numeric: false, disablePadding: true, label: 'Withdrawn Amount',
      },
      {
        id: 'cdkAmount', numeric: false, disablePadding: true, label: 'CDK Amount',
      },
      {
        id: 'deductionAmount', numeric: false, disablePadding: true, label: 'Deduction Amount',
      },
      {
        id: '', numeric: true, disablePadding: false, label: 'Action',
      },

    ].filter(header => header !== null);
    return tableHeaders;
  }

  // Define data for csv download; return object with headers and data
  getCSV = (payments) => {
    const data = [];

    for (let i = 0; i < payments.length; i += 1) {
      const payment = payments[i];

      // Standard CSV rows
      const dataRow = {
        userName: payment.userName,
        userEmail: payment.userEmail,
        paymentEmail: payment.paymentEmail,
        totalPayment: typeof payment.rollInSum === 'number'? getCurCurrencyOfUnit(payment.currency,payment.rollInSum): '-',
        walletBalance: typeof payment.balance === 'number'? getCurCurrencyOfUnit(payment.currency,payment.balance): '-',
        withdrawnAmount: typeof payment.withdrawSum === 'number'? getCurCurrencyOfUnit(payment.currency,payment.withdrawSum): '-',
        cdkAmount: typeof payment.cdkOrderSum === 'number'? getCurCurrencyOfUnit(payment.currency,payment.cdkOrderSum): '-',
        deductionAmount: typeof payment.deduceSum === 'number'? getCurCurrencyOfUnit(payment.currency,payment.deduceSum): '-',
      };

      data.push(dataRow);
    }

    // Standard CSV headers
    const headers = [
      { label: 'UserName', key: 'userName' },
      { label: 'UserEmail', key: 'userEmail' },
      { label: 'PaymentEmail', key: 'paymentEmail' },
      { label: 'TotalPayment', key: 'totalPayment' },
      { label: 'WalletBalance', key: 'walletBalance' },
      { label: 'WithdrawnAmount', key: 'withdrawnAmount' },
      { label: 'CDKAmount', key: 'cdkAmount' },
      { label: 'DeductionAmount', key: 'deductionAmount' },
    ];

    return { headers, data };
  }

  // Call api to pull down paypal payments.
  refreshRollOuts() {
    const { token } = this.props.auth;
    this.props.getPaypalPayments(token);
    this.setState({
      //paypalLoading: true,
    });
  }

  openDownloadModal1 = () => {
    const { token} = this.props.auth;
    //const isAdmin = user.role === 'admin';
    //const isHelper = user.role === 'helper';
    const isTransactions = inAdminPermissions('Transactions');
    //console.log('isFinance',isFinance);
    if (isTransactions) {
      this.props.getReconciliationRollCsv(0,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), this.state.sorting, token,0);
      this.setState({
        downloadModal: true,
      });
    }
  }

  closeDownloadModal = () => {
    this.setState({
      downloadModal: false,
    });
  }


  renderDownloadModal() {
    const { isLoading, data: payments } = this.props.admin.reconciliationRollsCsv;
    const csv = this.getCSV(payments);
//console.log(isLoading);
    return (
      <section className="ModalMaster active">
        <section className="Modal active">
          <button onClick={this.closeDownloadModal.bind(this)} className="Modal__layer" aria-hidden />
          <section className="Modal__wrapper Modal__download">
            {
              (isLoading) &&
              <div className="Modal__download--spinner">
                <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
              </div>
            }
            {
              (!isLoading) &&
              <div className="Modal__download--content">
                <div className="Modal__download--header">
                  Download
                </div>
                <div className="Modal__download--body">
                  <div className="Modal__download--row">
                    <CSVLink data={csv.data} headers={csv.headers} filename={`Reconciliation-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />&nbsp;{`Search Results (${payments.length})`}
                    </CSVLink>
                  </div>
                </div>
                <div className="Modal__download--footer">
                  <button
                    onClick={this.closeDownloadModal.bind(this)}
                    className="Modal__download--cta"
                  >
                    <i className="fa fa-times" />&nbsp;Close
                  </button>
                </div>
              </div>
            }
          </section>
        </section>
      </section>
    );
  }

  onDrop = (file) => {

    if (file?.target?.files[0]) {
      /* this.setState({
        uploading: req.id,
      }); */

      this.uploadFile(file?.target?.files[0]);
    }
  }

  uploadFile = (file) => {
    const { token } = this.props.auth;

    const formData = new FormData();
    formData.append("file", file);

    Axios({
      method: 'POST',
      url: '/api/v1/admin/user/update-tickets',
      headers: {
        Authorization: `JWT ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,

    }).then(res => {

      alert('success');
    })
    .catch(err => {
      console.log(err, "err");
      alert('upload failed');
    });
  };

  approveOrder = (orderId,approveType) => {
    //console.log(orderId,approveType);
    if(!orderId||!approveType){
      return;
    }
    const { token } = this.props.auth;

    if (!this.props.admin.approve.isLoading) {
      this.props.approveRollOut(orderId,approveType, token);
    }
  }

  handleConfirmClose = () => {
    this.setState({ dialogConfirmOpen: false,balanceTip: "",deductNoteTip: ""});
  };

  handleConfirmOpen = (userId,userName,walletBalance,accountBalance,currency,email) => {
    this.setState({ dialogConfirmOpen: true,deductOrder:{userId:userId,userName:userName,walletBalance:walletBalance,balance:'',currency:currency,email:email,deductNote:'',accountBalance:accountBalance}});
  };

  handleRefuseClose = () => {
    this.setState({ dialogRefuseOpen: false});
  };

  handleRefuseOpen = (orderId,balance,userName,currency) => {
    this.setState({ dialogRefuseOpen: true,deductOrder:{orderId:orderId,balance:balance,userName:userName,currency:currency}});
  };

  handleResultClose = () => {
    this.setState({ dialogResultOpen: false});
    //this.props.getUserWallet();
  };

  handleResultOpen = () => {
    this.setState({ dialogResultOpen: true});
  };

  handleRefuseResultClose = () => {
    this.setState({ dialogRefuseResultOpen: false});
    //this.props.getUserWallet();
  };

  handleRefuseResultOpen = () => {
    this.setState({ dialogRefuseResultOpen: true});
  };

  submitOrder=()=>{
    if(!this.state.deductOrder||!this.state.filters.region){
      return;
    }
    //console.log(this.state.deductOrder.balance,this.state.deductOrder.walletBalance,this.state.deductOrder.accountBalance,this.state.deductOrder.deductNote)
    if(!this.state.deductOrder.balance||isNaN(this.state.deductOrder.balance)||this.state.deductOrder.balance<=0){
      this.setState({ balanceTip: "Deduction amount must be ＞ 0"});
      return;
    }
    if(this.state.deductOrder.balance>this.state.deductOrder.walletBalance){
      this.setState({ balanceTip: "Insufficient wallet balance"});
      return;
    }
    if(this.state.deductOrder.balance>this.state.deductOrder.accountBalance){
      this.setState({ balanceTip: "The available amount is insufficient"});
      return;
    }
    if(!this.state.deductOrder.deductNote){
      this.setState({ deductNoteTip: "This field is required"});
      return;
    }
      const { token } = this.props.auth;
    //this.props.approveRollOut(this.state.withdrawOrder.orderId,1,token);
    this.props.deductRoll(this.state.deductOrder.userId,this.state.deductOrder.balance,this.state.filters.region,this.state.deductOrder.deductNote,1,token);
    //this.setState({ approveType: 1});
    this.handleConfirmClose();
    //this.handleResultOpen();
  }

  refuseOrder=()=>{
    if(!this.state.deductOrder||!this.state.deductOrder.orderId){
      return;
    }
    const { token } = this.props.auth;
    this.props.revokeDeduct(this.state.deductOrder.orderId,2,token);
    //this.setState({ approveType: 2});
    this.handleRefuseClose();
    //this.handleResultOpen();
  }

  payOrder=()=>{
    const { approvalLink,isLoading} = this.props.admin.orderLink.data;
    //console.log(approvalLink);
    if(!isLoading){
      if(approvalLink){
        window.open(approvalLink, "_blank");
      }
    }
    this.handleResultClose();
  }

  handlePayOrderResult=(result)=>{
    if(result==='success'){
      this.setState({ payResult: true,payResultOpen:true});
    }else{
      this.setState({ payResult: false,payResultOpen:true});
    }
    this.handleConfirmClose();
  }

  handlePayOrderResultClose=()=>{
    this.setState({ payResultOpen:false});
    this.doSearch();
  }

  handlePayRemindOpen=()=>{
    this.setState({ payRemind:true});
  }

  handlePayRemindClose=()=>{
    this.setState({ payRemind:false});
  }

  handlePayRemindConfirm=()=>{
    this.setState({ payRemind:false,payBatch:true});
  }

  handleChangeSel(event,payment) {
    const isChecked = event.target.checked;
    const { paymentsSel } = this.state;
    let sel;
    if(isChecked){
      if(paymentsSel.findIndex(r=>r.orderId===payment.orderId)<0){
        paymentsSel.push(payment);
      }
      sel=paymentsSel;
    }else{
      sel=paymentsSel.filter(r=>r.orderId!==payment.orderId);
    }
    this.setState({
      paymentsSel: sel,
    });
  }

  clearSelectAll = () => {
    this.setState((prevState) => ({
      paymentsSel: []
    }))
  }

  selectAll = () => {
    const { data: payments} = this.props.admin.rollOuts||{};
    this.setState((prevState) => ({
      paymentsSel: payments
    }))
  }

  handleConfirmBatchOpen = () => {
    this.setState({ dialogConfirmBatchOpen: true});
  };

  handleConfirmBatchClose = () => {
    this.setState({ dialogConfirmBatchOpen: false});
  };

  submitOrders=()=>{
    const { isLoading} = this.props.admin.approve;
    if(!isLoading) {
      const {token} = this.props.auth;
      //this.props.approveRollOut(this.state.withdrawOrder.orderId,1,token);
      this.props.showRollOutsPay(this.state.paymentsSel.map(sel=>sel.orderId), token);
      this.setState({approveType: 1});
      this.handleConfirmBatchClose();
      //this.handleResultOpen();
    }
  }

  handleBatchSuccessConfirmationClose = () => {
    this.setState({ dialogBatchSuccessOpen: false});
  };

  handleBatchFailureConfirmationClose = () => {
    this.setState({ dialogBatchFailureOpen: false});
  };

  handlePayNote = () => {
    return this.state.payNote;
  }

  handleDeduceItem = (userId) => {
    const {questTableUserId} = this.state;
    if(questTableUserId&&questTableUserId===userId){
      this.setState({ questTableUserId: ""});
    }else{
      this.setState({ questTableUserId: userId});
    }
  }

  handleRollIns = (userName) =>{
    this.props.changeIndex(0,{dateBegin:this.state.filters.startDate,dateEnd:this.state.filters.endDate,search:userName});
  }

  handleRollOuts = (userName) =>{
    this.props.changeIndex(1,{dateBegin:this.state.filters.startDate,dateEnd:this.state.filters.endDate,search:userName});
  }

  handleCDKOrders = (userName) =>{
    const { user } = this.props.auth;
    const isFinance = inFinance(user);
    this.props.changeIndex(isFinance?3:2,{dateBegin:this.state.filters.startDate,dateEnd:this.state.filters.endDate,search:userName});
  }

  handleAbnormalChange = () =>{
    const { time:et} = this.props.admin.reconciliationRolls||{};
    //const date = new Date(et);
    //console.log('handleAllChange',et,date.toISOString().split('T')[0],date.toLocaleString('sv-SE',dateOptions));
    this.handleSelectIndexDateChange(new Date(et),new Date(),1);
    this.setState({ selectIndex: -1});
  }

  handleAllChange = () =>{
    const { time:et} = this.props.admin.reconciliationRolls||{};
    //const date = new Date(et);
    //console.log('handleAllChange',et,date.toISOString().split('T')[0],date.toLocaleString('sv-SE',dateOptions));
    this.handleSelectIndexDateChange(new Date(et),new Date());
    this.setState({ selectIndex: 1});
  }

  handleMonthChange = () =>{
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1,0,0,0);
    //console.log('handleMonthChange',firstDayOfMonth,firstDayOfMonth.toISOString().split('T')[0],firstDayOfMonth.toLocaleString('sv-SE',dateOptions));
    this.handleSelectIndexDateChange(firstDayOfMonth,new Date());
    this.setState({ selectIndex: 2});
  }

  handleLastMonthChange = () =>{
    const today = new Date();

    const lastMonthYear = today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear();
    const lastMonth = today.getMonth() === 0 ? 11 : today.getMonth() - 1;

    const firstDayOfMonth = new Date(lastMonthYear, lastMonth, 1,0,0,0);
    //console.log('handleMonthChange',firstDayOfMonth,firstDayOfMonth.toISOString().split('T')[0],firstDayOfMonth.toLocaleString('sv-SE',dateOptions));
    const lastDayOfMonth = new Date(lastMonthYear, lastMonth+1, 0,23,59,59);
    this.handleSelectIndexDateChange(firstDayOfMonth,lastDayOfMonth);
    this.setState({ selectIndex: 3});
  }

  handleYearChange = () =>{
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), 0, 1,0,0,0);
    //console.log('handleMonthChange',firstDayOfMonth,firstDayOfMonth.toISOString().split('T')[0],firstDayOfMonth.toLocaleString('sv-SE',dateOptions));
    this.handleSelectIndexDateChange(firstDayOfMonth,today);
    this.setState({ selectIndex: 4});
  }

  handleWalletError = (errorUserId) =>{
    if(!errorUserId){
      return;
    }
    const { token } = this.props.auth;
    this.props.approveUserWalletError(errorUserId,this.state.filters.region,token);
  }

  render() {
    const { data: payments,sum:recSum, isLoading, pagination={totalUsers:0,totalPages:0,pageNumber:0}} = this.props.admin.reconciliationRolls||{};
    //const {isTipLoading, tipPagination } = this.props.admin.rollOutsAll;
    //const { isLoading: paypalLoading, errors: paypalError } = this.props.admin.rollOuts;
    const { search,approveType} = this.state;
    const {startDate:dateStart,endDate:dateEnd} = this.state.filters;
    //const { role } = this.props.auth.user;
    const isTransactions = inAdminPermissions('Transactions');
    //const isHelper = role === 'helper';
    //const isFinance = inFinance(this.props.auth.user);
    //const { orderId:approveOrderId } = this.props.admin.approve.data;
    const { isLoading:errorLoading,hasError} = this.props.admin.orderLink.errors;
    const { isLoading:approveLoading,hasError:hasApproveError} = this.props.admin.deduct.errors;
    const { hasError:hasRevokeError} = this.props.admin.revokeDeduct.errors;
    //const { approvalLink} = this.props.admin.orderLink.data;
    //console.log(this.props.admin.approve);
    const { deductOrder,dialogConfirmOpen,dialogRefuseOpen,dialogResultOpen,dialogRefuseResultOpen,payRemind,dialogConfirmBatchOpen } = this.state;
    //console.log(this.props.admin.approve.errors);
    //console.log(dateStart,typeof  dateStart);
    //console.log(dateEnd,typeof  dateEnd);
    //let hasError=false;
    //let haRes=false;
    const queryRegion = this.props?.auth?.user?.permission?.regions?.find(r=>r.id===this.state.filters.region);
    //console.log(queryRegion,recSum,this.props?.auth?.user?.permission,payments)
    const createSortHandler = property => (event) => {
      this.handleRequestSort(event, property);
    };
    //this.props.tip(tipPagination?tipPagination.totalUsers:0);
    return (
      <section className="APaymentList">
        <section className="APaymentList__wrapper">
          {isTransactions && (<h2 className="APaymentList__title">
            <span> RECORDS: { pagination?pagination.totalUsers:0 } (Page {((pagination?pagination.totalPages:0)>=1)?pagination.pageNumber:0} of {pagination.totalPages})</span>
          </h2>)}
          <section className="ToggleTable">
            <section className="ToggleTable__header">
              <div className="ToggleTable__header__left">
                <div className="RecTotal">
                  <div className="RecTotalRemark">Total Payment</div>
                  <div className="RecTotalTitle">{getCurCurrencyOfUnit(queryRegion?.currency,recSum?.rollIn||0)}</div>
                </div>
                <div className="RecItems">
                  <div className="RecItemDiv">
                    <div className="RecItem">
                      <div className="RecItemRemark">Total Wallet Balance</div>
                      <div className="RecItemTitle">{getCurCurrencyOfUnit(queryRegion?.currency,recSum?.balance||0)}</div>
                    </div>
                    <div className="RecItem">
                      <div className="RecItemRemark">Total Amount Withdrawn</div>
                      <div className="RecItemTitle">{getCurCurrencyOfUnit(queryRegion?.currency,recSum?.withdraw||0)}</div>
                    </div>
                    <div className="RecItem">
                      <div className="RecItemRemark">Total Wallet Purchases</div>
                      <div className="RecItemTitle">{getCurCurrencyOfUnit(queryRegion?.currency,recSum?.cdkOrder||0)}</div>
                    </div>
                    <div style={{marginLeft:'60px'}}>
                      <div style={{textAlign:'right'}}>
                        <span className={this.state.selectIndex===-1?"SelItem Selected":"SelItem"} onClick={this.handleAbnormalChange.bind(this)} style={{color:"red"}}>All Abnormal</span>
                        <span className={this.state.selectIndex===1?"SelItem Selected":"SelItem"} onClick={this.handleAllChange.bind(this)}>All</span>
                        <span className={this.state.selectIndex===2?"SelItem Selected":"SelItem"} onClick={this.handleMonthChange.bind(this)}>This Month</span>
                        <span className={this.state.selectIndex===3?"SelItem Selected":"SelItem"} onClick={this.handleLastMonthChange.bind(this)}>Last Month</span>
                        <span className={this.state.selectIndex===4?"SelItem Selected":"SelItem"} onClick={this.handleYearChange.bind(this)}>This Year</span>
                      </div>
                      <div style={{display:'flex'}}>
                        <Typography className="date_input_head_style">Reconciliation time</Typography>
                        {/* <label> */}
                        <input type='date' placeholder="Select Start Date" className='date_input_style' value={getLocalDay(dateStart)} onChange={(e) => this.handleStartDateChange(new Date(e.target.value))}/>
                        {/* </label> */}

                        <input type='date' placeholder="Select End Date" className='date_input_style' value={getLocalDay(dateEnd)} onChange={(e) =>this.handleEndDateChange(new Date(e.target.value))} min={dateStart}/>
                      </div>
                    </div>
                  </div>
                <div className="RecSearch">
                <div className="Search_Input">
                  <Icon color='#bfbfbf' name='search' />
                  <input
                    type="text"
                    id="search-bar-input"
                    label="SearchBarInput"
                    placeHolder="Please enter UserName,Multiple lines can be separated by commas"
                    value={search}
                    onChange={e => this.handleSearchChange(e)}
                    onKeyDown={(e) => e.key === 'Enter' && this.handleSearch()}
                  />
                </div>

                  <div style={{marginTop:'8px'}}>
                    { ((pagination?pagination.totalUsers:0)>0) && (
                        <button
                            style={{margin:'8px 10px 0px 100px'}}
                            onClick={this.openDownloadModal1.bind(this)}>
                          <i className="fa fa-download" />
                        </button>
                    )}
                  {(pagination?pagination.totalUsers:0)>0&&(<button className="regular" onClick={this.paginationLeft.bind(this)}>
                    <i className="fa fa-arrow-left" />
                  </button>)}
                  {(pagination?pagination.totalUsers:0)>0&&(<button className="regular" onClick={this.paginationRight.bind(this)}>
                    <i className="fa fa-arrow-right" />
                  </button>)}
                {/*<button style={{marginLeft:'10px'}} onClick={this.refreshRollOuts.bind(this)}>
                  Refresh Payments

                </button>*/}
                  </div>
                </div>
              </div>
              </div>
              <div className="ToggleTable__header__right" style={{display:'flex'}}>
                {/* <button
                  className={classNames('')}
                  onClick={this.openFiltersModal.bind(this)}
                >
                  Filters
                </button> */}

              </div>
            </section>
            <section className="ToggleTable__table-wrapper" style={{paddingTop:'0px',minHeight:'0px'}}>
              <section className="ToggleTable__table flex-table">
                {/*<div className="row">
                  <div
                    className="table-cell headline"
                  >
                    Filters: {this.renderFiltersString(false)}
                  </div>
                </div>*/}
                <Table>
                  <TableHead>
                    <TableRow>
                      {this.getTableHeaders().map(headCell => (
                        <TableHeaderCell
                          key={headCell.id}
                          align="center"
                          padding={headCell.disablePadding ? 'none' : 'default'}
                          sortDirection="desc"
                        >
                          <TableSortLabel
                            active={this.state.orderBy === headCell.id}
                            direction={this.state.order}
                            onClick={createSortHandler(headCell.id)}
                            IconComponent={ArrowDropDownIcon}
                            style={{ marginLeft: '30px' }}
                          >
                            {headCell.label}
                            {this.state.orderBy === headCell.id ? (
                              <span style={{ display: 'none' }}>
                                {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                              </span>
                          ) : null}
                          </TableSortLabel>
                        </TableHeaderCell>))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    { (!isLoading) &&
                    this.getRollOutsRows(payments)
                    }
                  </TableBody>
                </Table>
                <div className="NoPayments">
                  { (isLoading) &&
                    <div className="PaymentList__loading">
                      <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
                    </div>
                  }
                  { (!isLoading && !payments.length) &&
                    <span> No Records Found </span>
                  }
                </div>
              </section>
            </section>
            {(pagination?pagination.totalUsers:0)>0&&(<section className="ToggleTable__footer">
              <section className="ToggleTable__footer__left">
                <button onClick={this.paginationLeft.bind(this)}>
                  <i className="fa fa-caret-left" />
                </button>
              </section>
              <section className="ToggleTable__footer__right">
                <button onClick={this.paginationRight.bind(this)}>
                  <i className="fa fa-caret-right" />
                </button>
              </section>
            </section>)}
          </section>
        </section>
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!dialogConfirmOpen}
        >
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'space-between'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>UserName</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>{deductOrder.userName}</Typography>
            </div>
            <div style={{display:'flex',justifyContent:'space-between'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Wallet Balance</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>{getCurCurrencyOfUnit(deductOrder.currency,deductOrder.walletBalance ? roundingMoney(deductOrder.walletBalance, 2) : '0.00')}</Typography>
            </div>
            <div style={{display:'flex',justifyContent:'space-between'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Available Amount</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>{getCurCurrencyOfUnit(deductOrder.currency,deductOrder.accountBalance ? roundingMoney(deductOrder.accountBalance, 2) : '0.00')}</Typography>
            </div>
            <div style={{display:'flex',justifyContent:'space-between'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Deduction Amount</Typography>
              {this.state.balanceTip&&<Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',color:'red',fontSize:'14px'}}>
                {this.state.balanceTip}
              </Typography>}
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
              <input type="text" className="pay-note" label="deductAmountInput" value={this.state.deductOrder.balance} placeholder="Fill in the deduction amount here" maxLength="20" onChange={event => this.setState({ deductOrder:{...this.state.deductOrder,balance: event.target.value},balanceTip: ""})}/>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',marginTop:'10px'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Reason for deduction</Typography>
              {this.state.deductNoteTip&&<Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',color:'red',fontSize:'14px'}}>
                {this.state.deductNoteTip}
              </Typography>}
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
              <input type="text" className="pay-note" label="PayNoteInput" value={this.state.deductOrder.deductNote} placeholder="Fill in the reason for deduction here" maxLength="100" onChange={event => this.setState({ deductOrder:{...this.state.deductOrder,deductNote: event.target.value },deductNoteTip: ""})}/>
            </div>
            <div style={{display:'flex',justifyContent:'center',flexDirection:'column',marginTop:'10px'}}>
              <p style={{fontSize:'14px',color:'#9b9b9b',marginBottom:'0px'}}>· When making a deduction, if there is insufficient balance due to withdrawal, please cancel the withdrawal request of the user before making the deduction.</p>
              <p style={{fontSize:'14px',color:'#9b9b9b',marginTop:'0px'}}>· After the deduction, the system will notify the user email - {deductOrder.email}</p>
            </div>

          </DialogContent>
          <DialogActions>
            <div style={{display:'flex'}}>
            <div>
            <Button autoFocus style={{fontSize:'16px',fontWeight:'800',backgroundColor:'#0070ba',color:'#fff',borderRadius:'10px',padding:'10px 30px',textTransform:'none',height:'35px',width:'220px'}} onClick={this.handleConfirmClose.bind(this)}>
              Cancel
            </Button>
            </div>
              <div>
            <Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#0070ba',color:'#fff',borderRadius:'10px',padding:'10px 30px',textTransform:'none',height:'35px',width:'220px'}} onClick={this.submitOrder.bind(this)}>
              Make Deduction
            </Button>
              </div>
            </div>
          </DialogActions>
      </BootstrapDialog>

        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!dialogConfirmBatchOpen}
        >
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Order Quantity</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>{this.state.paymentsSel.length}</Typography>
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Amount Paid</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>{getCurCurrencyOfUnit(this.state.paymentsSel[0]?.currency,this.state.paymentsSel.reduce((totalPrice,env)=>{totalPrice+=env.balance;return totalPrice},0.00))}</Typography>
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Method Of Payment</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>PayPal Batch</Typography>
            </div>

          </DialogContent>
          <DialogActions>
            <div style={{display:'flex'}}>
              <div>
                <Button autoFocus style={{fontSize:'16px',fontWeight:'800',backgroundColor:'#0070ba',color:'#fff',borderRadius:'10px',padding:'10px 50px',textTransform:'none',height:'35px',width:'200px'}} onClick={this.handleConfirmBatchClose.bind(this)}>
                  Cancel
                </Button>
              </div>
              <Button style={{fontSize:'16px',fontWeight:'800',backgroundColor:'#0070ba',color:'#fff',borderRadius:'10px',padding:'10px 50px',textTransform:'none',height:'35px',marginLeft:'10px'}} onClick={this.submitOrders.bind(this)}>
              Make Payment
            </Button>
            </div>
          </DialogActions>
        </BootstrapDialog>

        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!dialogRefuseOpen}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" style={{color:hasError?'#ff0000':''}}>
            Do you confirm to revoke the deduction of <p style={{color:'#E7F328',display:'inline'}}>{getCurCurrencyOfUnit(deductOrder.currency,deductOrder.balance ? roundingMoney(deductOrder.balance, 2) : '0.00')}</p> from <p style={{color:'#E7F328',display:'inline'}}>{deductOrder.userName}'s </p> NOIZ wallet balance?
          </DialogTitle>
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',color:hasError?'#ff0000':''}}>

              </Typography>
            </div>
          </DialogContent>
          <DialogActions>
            <Button autoFocus style={{fontSize:'16px',fontWeight:'800',backgroundColor:'#CAC1C4',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.handleRefuseClose.bind(this)}>
              Cancel
            </Button>
            <Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#76b452',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.refuseOrder.bind(this)}>
              Confirm
            </Button>
          </DialogActions>
        </BootstrapDialog>

        {(!errorLoading||!approveLoading)&&((hasApproveError&&approveType===2)||approveType===1)&&<BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!false}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" style={{color:(hasError||hasApproveError)?'#ff0000':''}}>
            {approveType===1? 'Failure to deduction' : 'Failure to revoke deduction'}
          </DialogTitle>
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',color:hasError?'#ff0000':''}}>
                {approveType===1&&((hasError)?'': 'Withdrawal progress can be viewed in the transaction history')}
              </Typography>
            </div>
          </DialogContent>
          <DialogActions>
            <Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#CAC1C4',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.handleResultClose.bind(this)}>
              Close
            </Button>
            {(!hasError)&&(<Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#76b452',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.payOrder.bind(this)}>
              Confirm
            </Button>)}
          </DialogActions>
        </BootstrapDialog>}
        {this.state.dialogResultOpen&&hasApproveError&&<PromptDialog dialogOpen={this.state.dialogResultOpen} level="failure" title="Deduct failed!" content={'Please confirm if the balance is sufficient for deduct.'} cancelAction={this.handleResultClose}/>}
        {this.state.dialogResultOpen&&!hasApproveError&&<PromptDialog dialogOpen={this.state.dialogResultOpen} level="success" title="Deduct Successful!" content={'The user\'s account has been deducted.'} cancelAction={this.handleResultClose}/>}
        {dialogRefuseResultOpen&&!hasRevokeError&&<PromptDialog dialogOpen={dialogRefuseResultOpen} level="success" title="Revoke successful!" content={'The deducted amount from the user\'s wallet has been returned'} cancelAction={this.handleRefuseResultClose}/>}
        {dialogRefuseResultOpen&&hasRevokeError&&<PromptDialog dialogOpen={dialogRefuseResultOpen} level="failure" title="Failure to revoke." content={'Please confirm if there is an account issue.'} cancelAction={this.handleRefuseResultClose}/>}
        {payRemind&&<PromptDialog dialogOpen={dialogResultOpen} level="warn" title="Payment reminder" content={'Batch payment will incur a handling fee,which will be borne by NOIZ.Would you like to confirm the use of batch payment?'} cancelButtonName="Cancel" cancelAction={this.handlePayRemindClose} confirmButtonName="Make Payment" confirmAction={this.handlePayRemindConfirm}/>}
        {this.state.dialogBatchSuccessOpen&&<PromptDialog dialogOpen={this.state.dialogBatchSuccessOpen} level="success" title="Payment Successful!" content={'Amount:'+this.state.payBatchSuccess?.amount+' Order quantity:'+this.state.payBatchSuccess?.orderCount} cancelAction={this.handleBatchSuccessConfirmationClose}/>}
        {this.state.dialogBatchFailureOpen&&<PromptDialog dialogOpen={this.state.dialogBatchFailureOpen} level="failure" title="Payment failed!" content={'Please confirm if the balance is sufficient for payment.'} cancelAction={this.handleBatchFailureConfirmationClose}/>}
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!this.state.dialogBatchFailure.length>0}
        >
          <div className="block_5 flex-row justify-between">
            <div className="text-wrapper_7 flex-col">
              <span className="text_11">!</span>
            </div>
            <div className="text-wrapper_8 flex-col justify-between">
              <span className="text_12">WARNING</span>
              <span className="paragraph_1">
                    6 orders have been successfully paid, and the following 6 orders have failed to be paid. Please confirm if the balance is sufficient.
                    </span>
            </div>
          </div>


          <DialogContent dividers>
            <div className="block_6 flex-row">
              <div className="text-wrapper_9 flex-col">



              </div>
            </div>
          </DialogContent>
          <DialogActions style={{width:'100%',justifyContent:'space-evenly'}}>
            <div className="block_7 flex-row">
              <div className="text-wrapper_10 flex-col" onClick={this.handleBatchFailureConfirmationClose.bind(this)}>
                <span className="text_13">Close</span>
              </div>
            </div>
          </DialogActions>
        </BootstrapDialog>
        {/*{ (this.state.filtersModal) && this.renderFiltersModal() }*/}
        { (this.state.downloadModal) && this.renderDownloadModal() }
      </section>
    );
  }
}

Reconciliation.propTypes = {

};

export default Reconciliation;
